import React from 'react';
import { Button } from './Button';
import { Flame, Star, Check } from 'lucide-react';
export function Pricing() {
  return <section className="py-24 px-4 bg-[#0A1628] relative" id="precio-lanzamiento" data-id="element-229">
      <div className="max-w-6xl mx-auto" data-id="element-230">
        <div className="text-center mb-16" data-id="element-231">
          <h2 className="text-5xl md:text-7xl font-anton text-white mb-4" data-id="element-232">
            💥 PRECIO DE LANZAMIENTO
          </h2>
          <p className="text-xl text-gray-400" data-id="element-233">
            Elegí el plan que mejor se adapte a vos
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto items-center" data-id="element-234">
          {/* Card 1: Standard */}
          <div className="bg-[#0F1F3D] border border-white/10 rounded-3xl p-8 md:p-10 flex flex-col h-full" data-id="element-235">
            <h3 className="text-3xl font-anton text-white mb-2" data-id="element-236">
              📘 MEGAPACK PADEL RESUELTO
            </h3>
            <p className="text-xl text-[#C6F432] font-bold mb-8" data-id="element-237">
              6 Módulos + 6 Bonos
            </p>

            <div className="mt-auto" data-id="element-238">
              <div className="flex flex-col items-center mb-8" data-id="element-239">
                <span className="text-gray-400 line-through text-2xl font-bold" data-id="element-240">
                  $34.990
                </span>
                <span className="text-6xl font-anton text-white" data-id="element-241">$19.990</span>
                <span className="text-sm text-gray-400 mt-2" data-id="element-242">
                  Pesos Argentinos (ARS)
                </span>
              </div>
              <Button checkout className="w-full text-lg" data-id="element-243">
                👉 SÍ, QUIERO MI MEGAPACK
              </Button>
            </div>
          </div>

          {/* Card 2: Elite (Upsell) */}
          <div className="bg-gradient-to-b from-[#1a2f52] to-[#0F1F3D] border-2 border-[#C6F432] rounded-3xl p-8 md:p-10 relative transform lg:scale-105 shadow-[0_0_40px_rgba(198,244,50,0.15)] flex flex-col h-full" data-id="element-244">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-[#C6F432] text-[#0A1628] font-black px-6 py-2 rounded-full flex items-center gap-2 w-max shadow-lg" data-id="element-245">
              <Star size={18} className="fill-[#0A1628]" data-id="element-246" /> ⭐ MÁS ELEGIDO
            </div>

            <h3 className="text-3xl font-anton text-white mb-2 mt-4" data-id="element-247">
              🏆 PROFE ÉLITE PADEL™
            </h3>
            <p className="text-sm text-[#C6F432] font-bold mb-2 uppercase tracking-wider" data-id="element-248">
              SISTEMA DE NEGOCIO Y ESCALADO
            </p>
            <p className="text-lg text-white font-medium mb-6" data-id="element-249">
              6 Módulos + 6 Bonos + Sistema de Alumnos + Programa 90 Días
            </p>

            <div className="bg-white/5 rounded-xl p-4 mb-8" data-id="element-250">
              <p className="font-bold text-white mb-3 text-sm uppercase tracking-wider" data-id="element-251">
                ¿Qué agrega el PACK ÉLITE™?
              </p>
              <ul className="space-y-2" data-id="element-252">
                <li className="flex items-center gap-2 text-gray-200" data-id="element-253">
                  <Flame className="text-orange-500" size={18} data-id="element-254" /> Entrenamiento
                  avanzado
                </li>
                <li className="flex items-center gap-2 text-gray-200" data-id="element-255">
                  <Flame className="text-orange-500" size={18} data-id="element-256" /> Clases
                  tácticas
                </li>
                <li className="flex items-center gap-2 text-gray-200" data-id="element-257">
                  <Flame className="text-orange-500" size={18} data-id="element-258" /> Programa listo
                  para vender
                </li>
              </ul>
              <div className="mt-4 inline-flex items-center gap-2 text-[#C6F432] font-bold text-sm bg-[#C6F432]/10 px-3 py-1 rounded-full" data-id="element-259">
                💰 AUMENTÁS TUS INGRESOS
              </div>
            </div>

            <div className="mt-auto" data-id="element-260">
              <div className="flex flex-col items-center mb-8" data-id="element-261">
                <span className="text-gray-400 line-through text-2xl font-bold" data-id="element-262">
                  $43.990
                </span>
                <span className="text-7xl font-anton text-[#C6F432]" data-id="element-263">
                  $24.990
                </span>
                <span className="text-sm text-gray-400 mt-2" data-id="element-264">
                  Pesos Argentinos (ARS)
                </span>
              </div>
              <Button onClick={() => window.open('https://checkout.academiaonlinepro.shop/cart/47110791135417:1', '_blank')} className="w-full text-xl py-5 animate-pulse" data-id="element-265">
                👉 QUIERO EL PACK ÉLITE
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}